import React from "react";

const Hora = () => {
  return (
    <div className="clock-container">
      <div id="clock-wrapper"></div>
    </div>

    
  );
};

export default Hora;
